import Hero from "./Hero";
import { data } from "./data";
import wrapperClasses from "../../commons/Wrapper.module.scss";
import Problem from "./Problem";
import Solution from "./Solution";
import Banner from "./Banner";
import WhatWeDid from "./WhatWeDid";
import List from "./List";
import Push from "./Push";

const Nextres = () => {
  return (
    <>
      <section className={wrapperClasses.section}>
        <Hero
          title={data.hero.title}
          subtitle={data.hero.subtitle}
          text={data.hero.text}
        />
        <Problem
          title={data.problem.title}
          text={data.problem.text}
          tooltip={data.problem.tooltip}
        />
        <Solution title={data.solution.title} text={data.solution.text} />
        <WhatWeDid
          title={data.whatWeDid.title}
          text={data.whatWeDid.text}
          list={data.whatWeDid.list}
        />
        <List list={data.list} />
        <Push />
        <Banner />
      </section>
    </>
  );
};

export default Nextres;
